// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const RedirectCreateForm = registerClientReference(
    function() { throw new Error("Attempted to call RedirectCreateForm() from the server but RedirectCreateForm is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/super-seo/redirects/_form.tsx",
    "RedirectCreateForm",
);
export const RedirectRow = registerClientReference(
    function() { throw new Error("Attempted to call RedirectRow() from the server but RedirectRow is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/super-seo/redirects/_form.tsx",
    "RedirectRow",
);
